import { NgModule } from '@angular/core';
import { MyFilterFabricaPipe } from './my-filter-fabrica/my-filter-fabrica';
@NgModule({
	declarations: [MyFilterFabricaPipe
    ],
	imports: [],
	exports: [MyFilterFabricaPipe
    ]
})
export class PipesModule {}



// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts